import { useCallback } from 'react';

import ListItem from './ListItem';

const ColumnList = ({ items, setItems }) => {
	const setColumns = useCallback((dragIndex, hoverIndex) => {
		// Time to actually perform the action
		setItems((prevState) => {
			const tempState = [...prevState];
			tempState.splice(dragIndex, 1);
			tempState.splice(hoverIndex, 0, prevState[dragIndex]);
			return tempState;
		});
	}, []);

	const changeColumnVisibility = useCallback((name) => {
		setItems((prevState) => {
			const tempState = [...prevState];
			tempState.forEach((c) => {
				if (c.name === name) {
					c.show = !c.show;
				}
			});
			return tempState;
		});
	});

	return (
		<>
			{items.map((col, i) => (
				<ListItem
					key={i}
					index={i}
					column={col}
					setColumns={setColumns}
					onColumnVisibilityChange={changeColumnVisibility}
				/>
			))}
		</>
	);
};

export default ColumnList;
